export default {
  methods: {
    scroll(arg) {
      let el =
        typeof arg.to === "string" ? document.querySelector(arg.to) : arg.to;

      let offset = parseInt(arg.offset) || 0,
        duration = arg.duration || 800,
        easing = arg.easing || "easeOutExpo",
        callback = arg.callback || null;

      if (el) {
        anime({
          targets: ["html", "body"],
          scrollTop: el.offsetTop - offset, // $(el).offset().top
          duration: duration,
          easing: easing,
          complete: callback,
        }).finished.then(() => {
          bus.$emit("scroll:finished", true);
        });
      }
    },
  },
};
